/**
 * Scroll até o id da seção, compensando a topbar fixa (#menu).
 */
export function scrollToSectionId(id) {
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;

  const header = document.getElementById("menu");
  const offset = (header ? header.offsetHeight : 0) + 10;

  // 1) Scroll nativo suave para garantir compatibilidade em mobile
  el.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
  });

  // 2) Compensa a navbar fixa logo após iniciar o movimento
  window.setTimeout(() => {
    window.scrollBy({ top: -offset, behavior: "auto" });
  }, 40);
}
